import React from "react";
import { Switch, Table } from "antd";
import { useMarketingTypeModel } from "../allMemberMarketingTypeModel";
import { ColumnsType } from "antd/es/table";
import { IMdMarketingTypeDetail } from "../allMemberMarketingTypeTypes";
import moment from "moment";
import { getBaseImgLookUrl } from "@src/utils/constants";
import { momentFormats } from "@src/utils/utils";
import { YhAuth } from "@src/components/auth/YhAuth";
import { YhBut } from "@src/components/YhButton";
import { EditModeType } from "@src/types/FmsTypes";


export function DataTable() {
    const {
        dataSource,
        pgCfg,
        loadData,
        setDrawerVisible,
        setSelectedRow,
        setEditType,
    } = useMarketingTypeModel();


    const onDetail = (type: EditModeType, data: IMdMarketingTypeDetail) => {
            console.log(data)
            setDrawerVisible(true)
            setSelectedRow(data)
            setEditType(type)
    }

    const columns: ColumnsType<IMdMarketingTypeDetail> = [
    {
        align: 'center',
        title: '序号',
        width: 60,
        render: (v, r, i) => i + 1
    },
    {
        align: "center",
        title: '名称',
        width: 100,
        dataIndex: 'typeName',
    },
    {
        align: "center",
        title: '员工名称',
        width: 100,
        dataIndex: 'employeeName',
    },
    {
        align: "center",
        title: '创建人',
        width: 100,
        dataIndex: 'createUser',
    },
    {
        align: "center",
        title: '创建时间',
        width: 200,
        dataIndex: 'createTime',
        render: (value) => momentFormats(value)
    },
    {
        align: "center",
        title: '状态',
        dataIndex: 'status',
        width: 120,
        render: (v) => v === 1 ? "禁用" : "启用"
    },
     {
                align: "center",
                title: '操作',
                width: 120,
                dataIndex: 'enable',
                fixed: "right",
                render: (value, record, index) => {
                    return (
                        <>
                            <YhAuth resCode="portal2.am.type.vw">
                                <YhBut
                                    typeName="icon-chakan"
                                    text="查看"
                                    style={{ color: "#1296DB", fontSize: "18px" }}
                                    click={() => onDetail('look', record)}
                                />
                            </YhAuth>
                            <YhAuth resCode="portal2.am.type.ed">
                                <YhBut
                                    typeName="icon-bianji1"
                                    text="编辑"
                                    style={{ color: "#028E19", fontSize: "18px" }}
                                    click={() => onDetail('edit', record)}
                                />
                            </YhAuth>
                        </>
                    )
                }
            },
];



    return (
        <Table
            style={{ cursor: "pointer" }}
            columns={columns}
            dataSource={dataSource}
            rowKey={(record) => record.id}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
        />
    )
}


